// WS-75 life: the pale coat the animals share (animals.js for a single rigged animal, instancing.js for a whole herd in one
// draw), kept apart so the engine can load instancing.js without the animal loader.
import { attribute, vertexColor, materialColor, mix, max, sqrt } from 'three/tsl';

/**
 * The pale coat (WS-34 shadedMaterial): COLOR_0 x the material colour, blended by k to the baked white coat (`_colorpale`,
 * when the model has one) or to a lightened COLOR_0; tint (optional node) multiplies both, as instanceColor did.
 * Use with vertexColors = false (COLOR_0 is read here).
 */
export function paleCoat(hasPale, k, tint = null) {
  const t = (c) => (tint ? c.mul(tint) : c);
  const dc = t(materialColor.mul(vertexColor().rgb));
  // max(): MSAA shades edge samples with varyings extrapolated past the triangle, so vertex colours can dip below 0;
  // sqrt() of that is NaN, and bloom spreads one NaN pixel into a black frame.
  return hasPale ? mix(dc, max(t(attribute('_colorpale', 'vec3')), 0).mul(materialColor), k) : mix(dc, sqrt(max(dc, 0)).mul(0.82).add(0.08), k);
}
